export default __webpack_public_path__ + "a42ebf9e392f67ba89db3a96cdfcc280.png";